import { render, staticRenderFns } from "./moreHDPSL.vue?vue&type=template&id=1b6a1795&lang=pug&"
import script from "./moreHDPSL.vue?vue&type=script&lang=js&"
export * from "./moreHDPSL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports